import { Icons } from "../../../utils";
import AvailableUserChip from "./AvailableUserChip";

/* ================================================================
   AVAILABLE USERS CARD - Card avec utilisateurs disponibles (COMPACT)
================================================================ */
export default function AvailableUsersCard({ users, onAddUser }) {
  return (
    <div className="card">
      <div className="card-title">
        <Icons.Add />
        <h3>Utilisateurs disponibles ({users.length})</h3>
      </div>
      <div className="card-body">
        {users.length === 0 ? (
          <div className="empty-state">
            <Icons.Users />
            <p>Tous les utilisateurs sont déjà inscrits</p>
          </div>
        ) : (
          <div className="available-users-grid">
            {users.map((user) => (
              <AvailableUserChip
                key={user.id}
                user={user}
                onAdd={() => {
                  console.log("onAddUser", user.id);
                  onAddUser(user.id);
                }}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
